import { LitElement, PropertyValues, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { consume } from "@lit/context";
import { authContext, AuthState } from "@/context";

@customElement("sb-signed-in")
export class SignedIn extends LitElement {
  private _cachedChildren: Node[] = [];

  createRenderRoot() {
    return this; // stay in light DOM
  }

  connectedCallback(): void {
    super.connectedCallback();
    if (this._cachedChildren.length === 0) {
      // detach and cache children once
      this._cachedChildren = Array.from(this.childNodes);
      this._cachedChildren.forEach((c) => this.removeChild(c));
    }
  }

  @consume({ context: authContext, subscribe: true })
  @property({ attribute: false })
  auth?: AuthState;

  private tryRemoveFallback() {
    requestAnimationFrame(() => {
      const root = this as HTMLElement;

      const fallback = root.querySelector('[part="fallback"]');

      if (fallback) {
        fallback.remove();
      } else {
        console.warn("[sb-signup] fallback not found yet");
      }
    });
  }

  protected updated(_changedProperties: PropertyValues): void {
    if (_changedProperties.has("auth")) {
      this.tryRemoveFallback();
    }
  }

  render() {
    if (!this.auth || !this.auth?.isAuthenticated) return html``;

    return html` <div>${this._cachedChildren}</div> `;
  }
}
